import { FETCH_CUSTOMER_GROUPS_START, FETCH_CUSTOMER_GROUPS_SUCCESS, FETCH_CUSTOMER_GROUPS_FAILED } from "../actions/types";

export default (state = {}, action) => {
  switch (action.type) {
    case FETCH_CUSTOMER_GROUPS_START:
      return { ...state, inProgress: true };
    case FETCH_CUSTOMER_GROUPS_SUCCESS:
      return {
        ...state,
        list: action.payload.customerGroups,
        error: false,
        inProgress: false
      };
    case FETCH_CUSTOMER_GROUPS_FAILED:
      return { ...state, list: null, error: action.errors, inProgress: false };
    default:
      return state;
  }
};
